import {useEffect, useRef} from 'react';

export default function useAutoplayVideo() {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return undefined;

        video.muted = true;
        video.defaultMuted = true;

        const play = () => {
            if (!video.paused) return;
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
        };

        const onVisibilityChange = () => {
            if (!document.hidden) play();
        };

        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) play();
        }, {threshold: 0.05});

        observer.observe(video);
        video.addEventListener('canplay', play);
        window.addEventListener('pageshow', play);
        document.addEventListener('visibilitychange', onVisibilityChange);
        document.addEventListener('pointerdown', play, {once: true});
        document.addEventListener('touchstart', play, {once: true, passive: true});
        document.addEventListener('keydown', play, {once: true});
        play();

        return () => {
            observer.disconnect();
            video.removeEventListener('canplay', play);
            window.removeEventListener('pageshow', play);
            document.removeEventListener('visibilitychange', onVisibilityChange);
            document.removeEventListener('pointerdown', play);
            document.removeEventListener('touchstart', play);
            document.removeEventListener('keydown', play);
        };
    }, []);

    return videoRef;
}
